/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl, KTIcon} from '../../../helpers'
import {useThemeMode, systemMode} from '../../layout/theme-mode/ThemeModeProvider'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const {mode} = useThemeMode()
  const isDarkMode = mode === 'dark' || (mode === 'system' && systemMode === 'dark')

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5' style={{
            backgroundColor: isDarkMode ? 'rgba(0, 158, 247, 0.1)' : 'rgba(0, 158, 247, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: isDarkMode ? '1px solid rgba(0, 158, 247, 0.2)' : '1px solid rgba(0, 158, 247, 0.2)',
            width: '50px',
            height: '50px'
          }}>
            <KTIcon
              iconName='profile-circle'
              iconType='duotone'
              className='fs-3x text-primary'
            />
            <style>{`
              .menu .symbol .ki-duotone.ki-profile-circle { color: #009ef7; }
              .menu .symbol .ki-duotone.ki-profile-circle .path1 { opacity: 0.3; }
              .menu .symbol .ki-duotone.ki-profile-circle .path2 { opacity: 1; }
              .menu .symbol .ki-duotone.ki-profile-circle .path3 { opacity: 0.7; }
            `}</style>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.fullName}
            </div>
            <div className='fw-bolder d-flex align-items-center fs-5 text-muted'>
              {currentUser?.orgName}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span>
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
